var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4751 21.749C5.83706 21.749 1.24683 17.149 1.24683 11.499C1.24683 5.84902 5.83706 1.24902 11.4751 1.24902C17.1131 1.24902 21.7033 5.84902 21.7033 11.499C21.7033 17.149 17.1131 21.749 11.4751 21.749ZM11.4751 2.74902C6.65531 2.74902 2.74364 6.67902 2.74364 11.499C2.74364 16.319 6.65531 20.249 11.4751 20.249C16.2948 20.249 20.2065 16.319 20.2065 11.499C20.2065 6.67902 16.2948 2.74902 11.4751 2.74902Z",
    fill: "#091F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9546 22.749C21.765 22.749 21.5754 22.679 21.4257 22.529L19.4299 20.529C19.1405 20.239 19.1405 19.759 19.4299 19.469C19.7193 19.179 20.1983 19.179 20.4877 19.469L22.4834 21.469C22.7728 21.759 22.7728 22.239 22.4834 22.529C22.3337 22.679 22.1442 22.749 21.9546 22.749Z",
    fill: "#091F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7f565c38bb43f3eddaf363b974becb50.svg";
export { ForwardRef as ReactComponent };